<div class="fpe-wrap">

  <!-- Başlık input -->
  <div class="fpe-alan">
    <label class="fpe-label">Panel Başlığı</label>
    <input class="fpe-input" placeholder="Firmada Olanlar"
           [ngModel]="parametreler()?.ek?.baslik || ''"
           (ngModelChange)="baslikGuncelle($event)" />
  </div>

  <!-- Okuyucu listesi başlığı -->
  <div class="fpe-baslik-row">
    <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor"
         stroke-width="1.8" stroke-linecap="round">
      <rect x="2" y="5" width="20" height="14" rx="2"/>
      <line x1="2" y1="10" x2="22" y2="10"/>
    </svg>
    <span>Kart Okuyucuları Seç</span>
    <span class="fpe-sayi">{{ cihazlar().length }} cihaz</span>
  </div>

  <!-- Boş durum -->
  @if (cihazlar().length === 0) {
  <div class="fpe-bos">
    <div class="fpe-bos-ikon">📡</div>
    <div class="fpe-bos-yazi">Bağlı cihaz bulunamadı</div>
    <div class="fpe-bos-alt">Kart okuyucunun sunucuya bağlı olduğundan emin olun</div>
  </div>
  } @else {
  <div class="fpe-liste">
    @for (cihaz of cihazlar(); track cihaz.cihaz_kimlik) {
    <button class="fpe-cihaz" [class.secili]="seciliMi(cihaz.cihaz_kimlik)"
            (click)="toggle(cihaz)">
      <span class="fpe-led" [class.aktif]="true"></span>
      <div class="fpe-cihaz-icerik">
        <div class="fpe-cihaz-isim">{{ cihaz.cihaz_ismi || cihaz.cihaz_kimlik }}</div>
        <div class="fpe-cihaz-kimlik">{{ cihaz.cihaz_kimlik }}</div>
        <div class="fpe-cihaz-durum">{{ cihazDurumu(cihaz) }}</div>
      </div>
      <span class="fpe-check">{{ seciliMi(cihaz.cihaz_kimlik) ? '✓' : '' }}</span>
    </button>
    }
  </div>
  }

  <!-- Seçilenler -->
  @if (secilenler().length) {
  <div class="fpe-secilenler">
    <span class="fpe-secilenler-baslik">Seçilenler ({{ secilenler().length }})</span>
    <div class="fpe-badge-grup">
      @for (k of secilenler(); track k) {
      <span class="fpe-badge">
        {{ cihazIsmi(k) }}
        <button class="fpe-badge-x" (click)="cikar(k)">✕</button>
      </span>
      }
    </div>
  </div>
  }

</div>
